import router from '../services/router_service';
import collectionController from '../controllers/collection_controller';

router.on('route:collection', collectionController);
